import React from 'react';
import { SignupStatusProvider } from 'src/components/selfService/features/Signup/context/SignupStatusProvider/SignupStatusProvider';
import { SignupWizard } from 'src/components/selfService/features/Signup/pages/SignupWizard/SignupWizard';

export default function SignupPage(): JSX.Element {
  return (
    <SignupStatusProvider>
      <SignupWizard />
    </SignupStatusProvider>
  );
}
